<template>
    <tr @paste="paste">
        <template v-if="isLatLng">
            <td class="coordinate-number">
                <span class="idx">{{idx + 1}}</span>
                <coordinate-list-buttons :title="genitiveTitle"
                                         :can-add="hasParent" :can-remove="canBeRemoved"
                                         @add="add" @remove="remove">
                </coordinate-list-buttons>
            </td>
            <td><input type="text" v-model.lazy="items.lat"></td>
            <td><input type="text" v-model.lazy="items.lng"></td>
        </template>
        <template v-else>
            <b>{{title}} <span v-if="hasParent">{{idx + 1}}</span></b>
            <coordinate-list-buttons :title="genitiveTitle"
                                    :can-add="hasParent || isPolygon" :can-remove="canBeRemoved"
                                    @add="add" @remove="remove">
            </coordinate-list-buttons>
            <table>
                <tr v-if="isPoint || isRing">
                    <th>№</th>
                    <th>Широта</th>
                    <th>Долгота</th>
                </tr>
                <coordinate-list v-for="(item, idx) in items" :items="item" :idx="idx" :key="idx"></coordinate-list>
            </table>
        </template>
    </tr>
</template>

<style>
    .coordinate-number {
        position: relative;
    }

    .coordinate-number .coorditate-buttons {
        position: absolute;
        top: 8px;
        left: -2px;
        display: none;
    }

    tr:hover > .coordinate-number > .coorditate-buttons {
        display: block;
    }

    tr:hover > .coordinate-number > .idx {
        display: none;
    }
</style>

<script>
    import _ from 'lodash'
    import CoordinateUtils from '../CoordinateUtils'
    import CoordinateListButtons from './CoordinateListButtons.vue'

    export default {
        components: { CoordinateListButtons },
        props: ['items', 'idx'],
        name: 'coordinate-list',
        methods: {
            add() {
                let point = L.latLng(0, 0);

                if (this.isLatLng) {
                    // Если добавляется пара координат, добавляем такую же
                    let last = this.$parent.items[this.idx];
                    [point.lat, point.lng] = [last.lat, last.lng];
                }

                if (this.isPolygon) {
                    // Полигон может быть добавлен только если у него есть родитель,
                    // то есть мультиполигон, а значит, создаем массив с массивом с этой точкой
                    point = [[point]];

                    // Если у полигона нет родителя, то преобразовываем его в мультиполигон
                    if (!this.hasParent) {
                        let items = this.items.splice(0);
                        this.items.push(items, point);
                        return;
                    }
                }

                if (this.isRing) {
                    // Граница может быть добавлена только если у нее есть родитель,
                    // то есть полигон, а значит, создаем массив с этой точкой
                    point = [point];
                }

                // Добавляем к родительскому списку полученный элемент сразу за выбранным
                this.$parent.items.splice(this.idx + 1, 0, point);
            },

            remove() {
                this.$parent.items.splice(this.idx, 1);
            },

            paste(event) {
                if (this.isPoint || this.isRing) {
                    let text = (event.originalEvent || event).clipboardData.getData('text/plain');

                    if (text) {
                        let lines = text.split(/\r?\n/);
                        let latlngs = _.map(lines, CoordinateUtils.parseCoordinates);

                        _.remove(latlngs, _.isNil);

                        if (latlngs.length > 0) {
                            this.items.splice(0);
                            _.each(latlngs, point => this.items.push(point));

                            document.activeElement.blur();
                            event.preventDefault();
                        }
                    }
                }
            }
        },
        computed: {
            isMultyPolygon() {
                // Мультиполигон: массив массивов массивов коррдинат
                return Array.isArray(this.items) && Array.isArray(this.items[0]) && Array.isArray(this.items[0][0])
            },

            isPolygon() {
                // Полигон: массив массивов координат
                return Array.isArray(this.items) && Array.isArray(this.items[0]) && !Array.isArray(this.items[0][0]);
            },

            isRing() {
                // Граница: потомок полигона или массив координат
                let childOfPolygon = this.hasParent && this.$parent.isPolygon;
                let notSingle = Array.isArray(this.items) && this.items.length > 1;
                let containsLatLngs = _.some(this.items, item => item instanceof L.LatLng);

                return (childOfPolygon || notSingle) && containsLatLngs;
            },

            isPoint() {
                // Точка: не потомок полигона и массив с одной парой координат
                let childOfPolygon = this.hasParent && this.$parent.isPolygon;
                let single = Array.isArray(this.items) && this.items.length == 1;
                let containsLatLngs = _.some(this.items, item => item instanceof L.LatLng);

                return !childOfPolygon && single && containsLatLngs;
            },

            isLatLng() {
                // Пара координат
                return this.items instanceof L.LatLng;
            },

            hasParent() {
                // Потомок такого же компонента
                return this.$parent && this.$parent.$options.name == this.$options.name;
            },

            canBeRemoved() {
                // Удален может быть только потомок другого компонента, если он не является
                // последним (кроме потомков гранциы, которая содержит не менее трех точек)
                if (this.hasParent && _.isArray(this.$parent.items)) {
                    return this.$parent.items.length > (this.$parent.isRing ? 3 : 1);
                }
            },

            title() {
                if (this.isMultyPolygon) {
                    return "Мультиполигон";
                }

                if (this.isPolygon) {
                    return "Полигон";
                }

                if (this.isRing) {
                    return "Граница (" + (this.idx > 0 ? "внутренняя" : "внешняя") + ")";
                }

                if (this.isPoint) {
                    return "Точка";
                }
            },

            genitiveTitle() {
                if (this.isMultyPolygon) {
                    return "мультиполигон";
                }

                if (this.isPolygon) {
                    return "полигон";
                }

                if (this.isRing) {
                    return "границу";
                }

                return "точку";
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CoordinateList.vue?49da1800